import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformOrderResponse } from './transform';

import {
    SETSELECTED,
    RESET,
    SET as patientSET
} from 'one-state-subject/src/types';

import {
    setAction,
    reinitAction
} from 'one-state-orderstab/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

export const enum Types {
    SETPENDINGREFERRALS = 'one-state-pending-referrals/set',
}

/**
 * This Fuction will fetch the data of orders epic
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchOrdersRefEpic = (context: any) => (
    (action$: any) => {
        const { log, server, settings: { epicendpoints: { getpendingreferrals, apitoken }, uisettings: { dashboardapiconfig: {getpendingreferrals : getpendingreferralsApi}} } } = context;
        return action$.pipe(
            ofType(SETSELECTED),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the Referrals Response
                 */
                let dataresponse: any = action.payload;
                const getRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        // todo: need to refractor to include authorization in interface
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            "PatientID": datares?.id,
                        }
                        const response = server.post({
                            path: getpendingreferrals,
                            data: data,
                            headers: headers
                        })
                            .then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,orders-epic",
                                    "fetch-Orders-epic", {
                                    responseresult
                                }
                                );
                            })
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!getpendingreferralsApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformOrderResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.order)];
                            if (response.error) {
                                actions.push(addAction(response.error));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * This Fuction will clear data of orders epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearOrdersRefEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,orders-epic",
            "Reset-Orders-epic", {
        });
        return action$.pipe(
            ofType(patientSET, RESET),
            map(action => reinitAction())
        )
    }
);

